import { PropsWithChildren, useEffect } from "react";
import { useAuthStore } from "stores/authStore";

const WithConnectionHandler: React.FC<PropsWithChildren> = ({ children }) => {
  const setIsOffline = useAuthStore(state => state.setIsOffline);

  useEffect(() => {
    const handleConnection = () => {
      setIsOffline(!navigator.onLine);
    };

    window.addEventListener("online", handleConnection);
    window.addEventListener("offline", handleConnection);

    return () => {
      window.removeEventListener("online", handleConnection);
      window.removeEventListener("offline", handleConnection);
    };
  }, [navigator.onLine]);

  return <>{children}</>;
};

export default WithConnectionHandler;
